import {
  removeIE, customEventPolyfill, throttle, dispatchCustomEvent,
} from '../../tools/helpers';
import { CONFIG } from '../config';

// Polyfill
removeIE();
customEventPolyfill();
/* eslint-disable no-underscore-dangle,  */
export default class BfvEditProfile {
  /**
   * lightbox state
   * @type {boolean}
   */
  lightBoxIsOpen = false;

  /**
   * construct class
   * @param props
   */
  constructor(props = {}) {
    this.$root = props.element;
    this.$lightbox = this.$root.parentNode.querySelector('.js-bfv-edit-profile__lightbox');
    this.$lightboxCloseButton = this.$lightbox.parentNode.querySelector('.js-close-button');
    this.$scrollLightbox = this.$root.querySelector('.js-scroll-viewbox');
    this.$infos = this.$root.querySelectorAll('.bfv-edit-profile-bar__info');
    this.$baseControls = this.$root.querySelector('.js-bfv-edit-profile-bar__base-controls');
    this.$loadingInfo = this.$root.querySelector('.js-bfv-edit-profile-bar__loading');
    this.$deleteInfo = this.$root.querySelector('.js-bfv-edit-profile-bar__delete-info');
    this.$errorInfo = this.$root.querySelector('.js-bfv-edit-profile-bar__error-info');
    this.apiRouteDelete = this.$root.getAttribute('data-api-route-delete');
    this.timeScroll = 100;

    this.__showInfo(this.$baseControls);
  }

  /**
   * init class
   */
  init() {
    this.__bindEvents();
  }

  // <editor-fold defaultstate="collapsed" desc="*** helper ***">
  /**
   * bind class events
   * @private
   */
  __bindEvents() {
    try {
      this.$root.parentNode.querySelector('button.js-edit-profile')
        .addEventListener('click', (event) => this.__editAction(event));

      this.$root.querySelector('button.js-delete-profile')
        .addEventListener('click', (event) => this.__deleteAction(event));

      this.$root.querySelector('button.js-confirm-delete-info')
        .addEventListener('click', (event) => this.__resetAction(event));

      this.$root.querySelector('button.js-confirm-error-info')
        .addEventListener('click', (event) => this.__resetAction(event));

      if (this.$lightboxCloseButton) {
        this.$lightboxCloseButton.addEventListener('click', () => this.__toggleLightBoxOpen());
        this.initEventLightboxScroll();
      }
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  }

  /**
   * trigger Event on class open
   * @private
   */
  static __triggerEvent() {
    const lightBoxOpenEvent = new CustomEvent('bfvOverlay:opened', {
      bubbles: true,
      cancelable: false,
    });
    document.dispatchEvent(lightBoxOpenEvent);
  }

  /**
   * button click handler to open edit modal
   * @param ev
   * @private
   */
  __editAction(ev) {
    // no need to propagate click
    ev.preventDefault();
    ev.stopPropagation();

    this.__toggleLightBoxOpen();
  }

  __deleteAction(ev) {
    ev.preventDefault();
    ev.stopPropagation();

    this.__showInfo(this.$loadingInfo);

    window.divae.restApi
      .sendData(this.apiRouteDelete, '', 'application/json')
      .then((response) => {
        if (response && (response.status === 202 || response.status === 201 || response.status === 200)) {
          this.__showInfo(this.$deleteInfo);
          this.$root.querySelector('button.js-delete-profile').setAttribute('disabled', 'true');
        } else {
          this.__showInfo(this.$errorInfo);
          console.error(response);
        }
      })
      .catch((error) => {
        this.__showInfo(this.$errorInfo);
        console.error(error);
      });
  }

  __resetAction(ev) {
    ev.preventDefault();
    ev.stopPropagation();

    this.__showInfo(this.$baseControls);
  }

  __showInfo($infoElement) {
    this.$infos.forEach(($info) => {
      $info.classList.remove('bfv-edit-profile-bar__info--visible');
    });
    $infoElement.classList.add('bfv-edit-profile-bar__info--visible');
  }

  /**
   * toogle lightbox visibility
   * @private
   */
  __toggleLightBoxOpen() {
    if (!this.$lightbox) {
      return;
    }
    const lightBoxHasOpenClass = this.$lightbox.classList.contains('bfv-gallery-lightbox--closed');

    if (lightBoxHasOpenClass) {
      this.$lightbox.classList.remove('bfv-gallery-lightbox--closed');
      this.$lightbox.classList.add('bfv-gallery-lightbox--open');
      document.body.classList.add('lightbox--open');
      this.constructor.__triggerEvent();
    } else {
      this.$lightbox.classList.remove('bfv-gallery-lightbox--open');
      this.$lightbox.classList.add('bfv-gallery-lightbox--closed');
      document.body.classList.remove('lightbox--open');
    }
    this.lightBoxIsOpen = !lightBoxHasOpenClass;
  }

  initEventLightboxScroll() {
    this.$scrollLightbox.addEventListener('scroll', throttle(() => {
      this.handleEventLightboxScroll();
    }, this.timeScroll));
  }

  // noinspection JSMethodCanBeStatic
  handleEventLightboxScroll() {
    dispatchCustomEvent(
      CONFIG.events.LIGHTBOX_SCROLL,
    );
  }

  // </editor-fold>
}
